<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect6"><span href="#/OEBPS/toc#sect6" title="Link target outside of Sample">Oatmeal Coffee Cake</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/14-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 4–6 | Prep Time: 10 minutes | Cook Time: 25–30 minutes</p>
<p class="extract_r">Coffee cake always marked a special occasion growing up. If we were expecting overnight guests, my dad would pick up a coffee cake from the local bakery to serve in the morning alongside some freshly brewed coffee. It was such a fun treat, and with this lightened-up version, I don’t have to wait for a special occasion to indulge!</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">½ cup coconut oil, plus 1 tablespoon</p>
<p class="rec">2 large eggs</p>
<p class="rec">1¼ cups packed light brown sugar</p>
<p class="rec">1 cup cooked oatmeal, cooled</p>
<p class="rec">1 teaspoon vanilla extract</p>
<p class="rec">¾ cup whole wheat flour</p>
<p class="rec">¾ cup all-purpose flour</p>
<p class="rec">½ teaspoon kosher salt</p>
<p class="rec">1½ teaspoons cinnamon</p>
<p class="rec">1 teaspoon baking soda</p>
<p class="rec">1½ cups blueberries</p>
<p class="rec">¼ cup chopped walnuts</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. Preheat the oven to 350°F. Lightly coat an 8 × 8-inch baking dish with cooking spray.</p>
<p class="recpr">2. In a large bowl, combine ½ cup of the coconut oil, the eggs, 1 cup of the brown sugar, the oatmeal, and the vanilla.</p>
<p class="recpr">3. In a medium bowl, whisk together the whole wheat flour, all-purpose flour, salt, 1 teaspoon of the cinnamon, and the baking soda.</p>
<p class="recpr">4. Combine the dry ingredients with the wet and stir until combined.</p>
<p class="recpr">5. Gently fold in the blueberries.</p>
<p class="recpr">6. Pour into the baking dish.</p>
<p class="recpr">7. In a small bowl, mix together the remaining 1 tablespoon coconut oil, ¼ cup brown sugar, and ½ teaspoon cinnamon with the walnuts. Evenly sprinkle the mixture over the top of the cake.</p>
<p class="recpr">8. Bake for 25 to 30 minutes until the cake is set.</p>
<p class="recpr">9. Let the cake cool before cutting. Serve.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect6.vue?54f7a240